import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { AuthService } from '../../../auth/services/auth.service';
import { ErrorShellComponent } from '../../../layout/components/error-shell/error-shell.component';
import { ROUTES } from '../../../core/constants/routes.constants';

@Component({
  selector: 'app-page-not-found',
  imports: [RouterLink, ErrorShellComponent, TranslatePipe],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent {
  protected readonly authService = inject(AuthService);
  protected readonly routes = ROUTES;
}
